/**
 * Vesper v5 pool (`va*`) read surface.
 *
 * NOT ERC-4626 in any part — `asset()`, `totalAssets()`,
 * `convertToAssets()` and every `max*` view revert (probed live on
 * Ethereum / Base / Optimism 2026-08-27). The pool's own vocabulary:
 *
 *  - `token()`         — the deposit asset (WETH on the ETH pools).
 *  - `pricePerShare()` — raw UNDERLYING units per one whole (1e18) share.
 *    Shares are 18-decimal on every v5 pool regardless of the underlying,
 *    so vaUSDC answers `1298315` (= 1.298315 USDC) — the scale is the
 *    UNDERLYING's, not the share's.
 *  - `totalValue()`    — buffer + Σ strategy holdings, raw underlying. A
 *    live computed view, not a cached accumulator.
 *
 * The legacy v2 pools (vUSDC / vETH / vWBTC, version 2.0.0) answer
 * `token()` and `totalValue()` but NOT `pricePerShare()` — they are
 * deliberately not integrated (near-zero rates, run-off generation), and
 * the reader treats a missing `pricePerShare` as a broken entry rather
 * than deriving one, so a v2 address pasted into the registry fails loudly
 * instead of shipping with a subtly different price basis.
 */
export const VesperPoolReadAbi = [
  {
    name: 'pricePerShare',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'totalValue',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'totalSupply',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const
